import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import styles from './PostIt.module.sass'

const SlidingPostIt = (text, className, attributes) => {
	return (
		<div
			{...attributes}
			className={`${styles['root']} ${styles['sliding']} ${
				className || ''
			}`}
		>
			<SlidingText>
				<small>{text}</small>
			</SlidingText>
		</div>
	)
}

const TooltipPostIt = (text, placeholder, className, attributes) => {
	return (
		<Tooltip text={text}>
			<div
				{...attributes}
				className={`${styles['root']} ${styles['tooltip']} ${
					className || ''
				}`}
			>
				<small>{placeholder}</small>
			</div>
		</Tooltip>
	)
}

const PostIt = (props) => {
	const { data, className, ...attributes } = props
	const { text, type, placeholder } = data

	switch (type) {
		case 'sliding':
			return SlidingPostIt(text, className, attributes)
		case 'tooltip':
			return TooltipPostIt(text, placeholder, className, attributes)
		default:
			return SlidingPostIt(text, className, attributes)
	}
}

export default PostIt
